module.exports = __webpack_public_path__ + "static/media/cx.43581198.svg";